import type { SalesLookupVariant } from 'apis/sales-lookup';
import { Flex, Text } from 'design-system';
import { fullUomLabel } from 'pages/sales-lookup/utils/full-uom-label';
import { packagingWord } from 'pages/sales-lookup/utils/variants';

const InfoPill = ({ label, value }: { label: string; value: string }) => (
  <Flex align='baseline' bg='gray.50' border='1px solid' borderColor='gray.100' borderRadius='6px' px='6px' py='2px'>
    <Text fontSize='9px' fontWeight='bold' letterSpacing='0.06em' color='gray.400' mr='4px'>
      {label.toUpperCase()}
    </Text>
    <Text fontSize='11.5px' fontWeight='medium' color='gray.700'>
      {value}
    </Text>
  </Flex>
);

// Full card content for a variant inside the dropdown MENU: packaging and
// origin lead (what the salesperson is actually quoting); brand, state, spec
// and attributes trail as labelled pills so nothing about the variant is
// hidden. The option row itself supplies hover/selected background.
export const VariantMenuOption = ({ variant }: { variant: SalesLookupVariant }) => (
  <>
    <Text fontSize='13.5px' fontWeight='bold' color='gray.800'>
      {fullUomLabel(variant, packagingWord(variant))}
    </Text>
    <Text fontSize='12.5px' fontWeight='semibold' color='gray.600' mt='1px'>
      {variant.origin ?? 'Origin unknown'}
    </Text>
    <Flex flexWrap='wrap' mt='6px' style={{ gap: '4px' }}>
      <InfoPill label='Brand' value={variant.brand ?? 'No brand'} />
      {variant.state && <InfoPill label='State' value={variant.state} />}
      {variant.spec && <InfoPill label='Spec' value={variant.spec} />}
      {variant.attributes.map((a) => (
        <InfoPill key={a.attributeType} label={a.attributeType} value={a.attributeValue} />
      ))}
    </Flex>
  </>
);

// Compact one-liner for the closed control — the menu carries the detail.
export const VariantValueOption = ({ variant }: { variant: SalesLookupVariant }) => (
  <Flex align='baseline' minW='0'>
    <Text fontSize='13.5px' fontWeight='bold' color='gray.800' noOfLines={1}>
      {fullUomLabel(variant, packagingWord(variant))}
    </Text>
    <Text fontSize='12.5px' fontWeight='semibold' color='gray.600' ml='6px' noOfLines={1}>
      {variant.origin ?? 'Origin unknown'}
    </Text>
  </Flex>
);
